/**
 * Shared static-text helpers for Community components.
 *
 * Consolidates the getText(staticText, key, fallback) pattern that was
 * independently implemented in CreatePlaylistModal, VibeQuizModal, and
 * PlaylistSharedView.
 */

import { Map } from 'immutable'
import type { StaticTextMap } from '../types'

export default function getText (
  staticText: StaticTextMap,
  key: string,
  fallback: string,
): string {
  if (!Map.isMap(staticText)) return fallback
  return (staticText.getIn(['data', key]) as string) || fallback
}
